import { vif1 } from '@phi/util/vuetils';
import { defineComponent, h } from 'vue';
import VimeoEmbed from '../VimeoEmbed';
import { Button, Tooltip } from '@phi/components';
import { app_store_link } from '@phi/constants';
import { Flex } from '@phi/components/layout';
import { open_in_new_tab } from '@phi/util/window';
import { _01_basic_interactions_tooltip, _02_edge_design_tooltip, _03_more_viewing_options_tooltip, _04_pop_outs_tooltip, _05_moving_tooltip, _06_fixing_tooltip, _07_face_edge_shapes_tooltip, _08_smoothness_tooltip, _09_symmetry_tooltip, _10_precision_tooltip, _11_multiple_bodies_tooltip, _12_save_load_tooltip, _13_references_tooltip, _14_settings_tooltip } from './content-tooltips';

const tutorial_video_map: Record<number, string> = {
    1: '562665887',
    2: '562667687',
    3: '562666454',
    4: '562667236',
    5: '562676899',
    6: '562677724',
    7: '562682431',
    8: '562682943',
    9: '562683476',
    10: '562687647',
    11: '562688669',
    12: '562689051',
    13: '562752361',
    14: '562753458',
};

const default_video = '680887733';

export default defineComponent({
    props: {
        is_demo: {
            required: true,
            type: Boolean,
        },
        stage: {
            required: true,
            type: Number,
        },
    },

    emits: {
        'update:stage': (x: number) => true,
    },

    computed: {
        selected_variant() {
            return this.is_demo ? 'outlined' : 'primary';
        }
    },

    render() {
        return h(Flex, { direction: 'column' }, () => [
            h(VimeoEmbed, {
                src: tutorial_video_map[this.stage] || default_video,
                autoplay: false,
            }),

            TutorialButton(
                this.stage === 1 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 1),
                '1: Basic interactions and viewing',
                _01_basic_interactions_tooltip,
            ),

            TutorialButton(
                this.stage === 2 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 2),
                '2: Edge design',
                _02_edge_design_tooltip,
            ),

            TutorialButton(
                this.stage === 3 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 3),
                '3: More viewing, colors and materials',
                _03_more_viewing_options_tooltip,
            ),

            TutorialButton(
                this.stage === 4 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 4),
                '4: Pop-outs, holes, and bridges',
                _04_pop_outs_tooltip,
            ),

            TutorialButton(
                this.stage === 5 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 5),
                '5: Moving, scaling and dimensioning',
                _05_moving_tooltip,
            ),

            TutorialButton(
                this.stage === 6 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 6),
                '6: Fixing, dissolving and deleting',
                _06_fixing_tooltip,
            ),

            TutorialButton(
                this.stage === 7 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 7),
                '7: Face and edge shapes ',
                _07_face_edge_shapes_tooltip,
            ),

            TutorialButton(
                this.stage === 8 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 8),
                '8: Smoothness and continuity ',
                _08_smoothness_tooltip,
            ),

            TutorialButton(
                this.stage === 9 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 9),
                '9: Mirroring and symmetries ',
                _09_symmetry_tooltip,
            ),

            TutorialButton(
                this.stage === 10 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 10),
                '10: Dimensioning and precision',
                _10_precision_tooltip,
            ),

            TutorialButton(
                this.stage === 11 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 11),
                '11: Multiple bodies',
                _11_multiple_bodies_tooltip,
            ),

            TutorialButton(
                this.stage === 12 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 12),
                '12: Load, save, import, export',
                _12_save_load_tooltip,
            ),

            TutorialButton(
                this.stage === 13 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 13),
                '13: Reference objects and sketches',
                _13_references_tooltip,
            ),

            TutorialButton(
                this.stage === 14 ? undefined : this.selected_variant,
                () => this.$emit('update:stage', 14),
                '14: Settings, search and feedback',
                _14_settings_tooltip,
            ),

            vif1(this.is_demo)(() => h(Button, {
                variant: 'primary',
                onClick: () => open_in_new_tab(app_store_link),
            }, () => 'Get Phi Now!')),
        ]);
    },
});

function TutorialButton(variant: any, onClick: VoidFunction, label: string, tooltip: string) {
    return h(Tooltip, { timeout: 100, placement: 'left' }, {
        tooltip: () => h('div', { innerHTML: tooltip }),
        default: () => h(Button, {
            class: 'tut_stage_button',
            variant,
            onClick,
            block: true,
        }, () => label),
    });
}
